export default __webpack_public_path__ + "static/media/about.fdad99e3.png";